import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "页面未找到 - 三级片电影大全",
    description: "你访问的页面不存在，请返回首页浏览三级片影片资料与影视资讯。",
  });

  return (
    <SiteLayout>
      <div className="rise-in flex flex-col items-center justify-center rounded-lg border border-background-200 bg-background-50 px-6 py-20 text-center">
        <p className="font-heading text-6xl font-black text-primary-200">404</p>
        <h1 className="mt-4 text-xl font-bold text-foreground-950">页面未找到</h1>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
          这个地址可能已经失效，或者链接输入有误。你可以回到首页，或直接进入影片分类继续浏览。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-5-line" />
            返回首页
          </Link>
          <Link
            to="/category/drama"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-film-line" />
            浏览分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}